import { render, staticRenderFns } from "./StatsionarAnalitika.vue?vue&type=template&id=6eabb3a0&scoped=true"
import script from "./StatsionarAnalitika.vue?vue&type=script&lang=js"
export * from "./StatsionarAnalitika.vue?vue&type=script&lang=js"
import style0 from "./StatsionarAnalitika.vue?vue&type=style&index=0&id=6eabb3a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eabb3a0",
  null
  
)

export default component.exports